import { useState, useEffect } from 'react';

import { _ThirdLoanEntity } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ThirdLoanEntitySelect = ({ idSelector, onChange, label }: Props) => {

    const { instance } = useDataBean(_ThirdLoanEntity);
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {
        instance.getThirdLoanEntityCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Tercero Administrado:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDThirdLoanEntity} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}